import { create } from 'zustand';
import { DrugItem } from 'src/api/types';

interface State {
  setDrugListAnalytics: (analytics?: DrugItem['analytics']) => void;
  drugListAnalytics: DrugItem['analytics'] | null;
}

const useDrugListAnalyticsStore = create<State>()((set) => ({
  setDrugListAnalytics: async (analytics) => {
    set({ drugListAnalytics: analytics ?? null });
  },
  drugListAnalytics: null
}));

export default useDrugListAnalyticsStore;
